import { c as _c } from "react/compiler-runtime";
import { Box } from '@chakra-ui/react';
import { Checkbox } from '@/components/ui/checkbox';
import { InformationIcon } from '@/components/util-component/InformationIcon';
import { WarningOptions } from '@/services/networkReport/models/reportOptions';
const WarningOptionWithInfo = t0 => {
  const $ = _c(14);
  const {
    label,
    options,
    handleWarningOptionChange,
    info,
    warningOptionKey
  } = t0;
  const t1 = options[warningOptionKey];
  let t2;
  if ($[0] !== handleWarningOptionChange || $[1] !== warningOptionKey) {
    t2 = e => handleWarningOptionChange(warningOptionKey, !!e.checked);
    $[0] = handleWarningOptionChange;
    $[1] = warningOptionKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <Box whiteSpace="nowrap">{label}</Box>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = <Checkbox checked={t1} onCheckedChange={t2}>{t3}</Checkbox>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== info) {
    t5 = info && <Box style={{
      width: "20px",
      height: "20px",
      position: "absolute",
      right: "-6px",
      top: "-8px"
    }}><InformationIcon contentWidth="380px" info={info} whiteSpace="pre-line" /></Box>;
    $[9] = info;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Box display="flex" justifyContent="space-between" position="relative" width="100%">{t4}{t5}</Box>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default WarningOptionWithInfo;